<template>
    <div class="lang arabic">
        <div class="info">
            <h3 class="bullet01">خدمات الطوارئ</h3>
            <p class="depth bullet03">تتوفر الخدمات الطبية على مدار الساعة وطيلة أيام الأسبوع بغض النظر عن الاجازات الرسمية لمرضى الطوارئ (أو العمل).</p>
            <p class="depth bullet03">ولضمان استعدادنا لخدمة مرضى الطوارئ على مدار الساعة نحن مجهزون بمعدات طبية للطوارئ ومزودين بالكامل بطاقم طبي محترف نحن نسعى دائما لتقديم خدمات طوارئ سريعة يتلقى مرضى الطوارئ الرعاية الطبية مباشرة في غرفة الطوارئ لدينا بغض النظر عن نظام تقديم الرعاية الصحية (بغض النظر عن زيارة المؤسسات الطبية الأولية والثانوية) أو منطقتهم.</p>
            <p class="depth bullet03">في مركز الطوارئ، توجد شبكة الاتصال اللاسلكية ومعدات الطوارئ الطبية والإسعاف، وغيرها.</p>
            <p class="depth bullet03">في وضع الاستعداد على مدار الساعة وطيلة أيام الأسبوع لإنشاء شبكة طبية للطوارئ وتقليل الفجوات في الخدمة أثناء الليل وفي أيام العطل.</p>
        </div>
        <div class="info">
            <h3 class="bullet01">تسجيل خدمة الطوارئ</h3>
            <p class="depth">عند وصولك إلى موقع الطوارئ، يجب إجراء فحص طبي أولي في الغرفة للتحقق من خطورته وتقديم طلب للحصول على خدمة في مكتب الإدارة داخل مكتب الطوارئ، وتقديم نموذج طلب الخدمة وبطاقة التأمين الصحي (شهادة الرعاية الطبية) مع بطاقة هويتك.</p>
            <p class="depth">بمجرد أن يصدر لك مكتب الإدارة علامة اسم المريض في حالات الطوارئ وسوار المريض، سلم هؤلاء إلى مكتب الممرضة</p>
        </div>
        <div class="info">
            <h3 class="bullet01">خدمة الطوارئ</h3>
            <p class="depth">سيقرر طبيب الطوارئ ما إذا كنت ستغادر المستشفى بعد العلاج أو سيم إدخالك إلى المستشفى</p>
        </div>
        <div class="info">
            <h3 class="bullet01">الدفع مقابل خدمة الطوارئ</h3>
            <p class="depth">تدفع الرسوم الطبية لمريض الطوارئ فورا عند قرار خروجه من المستشفى ومع ذلك، سيتم دفع رسوم الإجراءات الخاصة (التصوير بالرنين المغناطيسي، الأشعة المقطعية، التصوير بالموجات فوق الصوتية) قبل كل إجراء.</p>
            <p class="depth">وينبغي أن يدفع المرضى الذين لم يتم تأكيد شمولهم في التأمين الصحي أو في الرعاية الطبية المبلغ بالكامل.</p>
            <p class="depth">يمكن الدفع بواسطة بطاقة الائتمان.</p>
        </div>
        <div class="info">
            <h3 class="bullet01">تسجيل المغادرة والإقامة في المستشفى</h3>
            <div class="table">
                <table>
                    <colgroup>
                        <col style="width: 50%;">
                        <col style="width: 50%;">
                    </colgroup>
                    <thead>
                        <tr>
                            <th>خدمات الطوارئ</th>
                            <th>قبول</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>
                                يرجى تسجيل المغادرة وقم بتسليم إيصال الدفع إلى إحدى الممرضات لتلقي الدواء الخاص بك وإبلاغك بجدول العلاج التالي والاحتياطات في المنزل قبل العودة إلى المنزل.
                            </td>
                            <td>
                                عند إقامتك في المستشفى ، تحصل على المساعدة من الممرضة المسؤولة أثناء تسجيل الوصول وإكمال عملية الدخول في طلب الطوارئ /مكتب الدفع.
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>
<script>
    export default {

    }
</script>